export { default as List } from 'companies/containers/CompaniesListContainer';
export { default as Form } from 'companies/containers/CompanyFormContainer';
export { default as Permisions } from 'companies/containers/CompanyPermisionsContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/containers/index.js